export class HomePartnersResponse extends Array<HomePartnersResponse> {
    constructor() {
      super();
      this.id = 0;
      this.partnerthumb = "";
    }
    public id: number;
    public partnerthumb: string;
  }
  